import React, { useLayoutEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useSidebarContext } from '../../context/SidebarContext';
import './ResponsiveContentWrapper.css';

/**
 * ResponsiveContentWrapper dynamically adjusts its margin and width
 * based on sidebar expanded/collapsed state using MUI responsive features
 */
const ResponsiveContentWrapper = ({ children, className = "", sx: sxProp = {}, noTopMargin = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  const { sidebarWidth, isAnySidebarStateExpanded } = useSidebarContext();

  // Set CSS variable before paint so first load matches refresh (no padding 0 / wrong overflow)
  useLayoutEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', `${sidebarWidth}px`);
  }, [sidebarWidth]);

  /* When embedded (noTopMargin), inherit parent layout - no sidebar offset (parent handles it) */
  const isEmbedded = noTopMargin;

  return (
    <Box
      className={`right-content-wrapper right-content-wraper responsive-wrapper ${noTopMargin ? 'no-top-margin' : ''} ${className}`}
      sx={{
        marginLeft: isEmbedded ? 0 : (isMobile ? 0 : `${sidebarWidth}px`),
        width: isEmbedded ? '100%' : (isMobile ? '100%' : `calc(100% - ${sidebarWidth}px)`),
        boxSizing: 'border-box',
        height: isEmbedded ? 'auto' : 'calc(100vh - 80px)',
        overflowY: isEmbedded ? 'visible' : 'auto',
        overflowX: 'hidden',
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: noTopMargin ? 0 : '80px',
        paddingLeft: noTopMargin ? 0 : { xs: 1, sm: 1.5, md: 2.25 },
        paddingRight: noTopMargin ? 0 : { xs: 1, sm: 1.5, md: 2.25 },
        transition: theme.transitions.create(['margin-left', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        '& .container': {
          width: '100%',
          margin: 0,
          maxWidth: 'none',
        },
        ...sxProp,
      }}
    >
      {children}
    </Box>
  );
};

export default ResponsiveContentWrapper;
